export enum Theme {
	GREEN = 'green',
}
